// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { router } from './router'
import moment from 'moment'

import vueEsign from 'vue-esign'
Vue.use(vueEsign)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import VueLuckyCanvas from '@lucky-canvas/vue'
Vue.use(VueLuckyCanvas)

import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI)

Vue.config.productionTip = false

Vue.filter('format', function(timestamp, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment.unix(timestamp).format(pattern)
})

Vue.filter('appendZero', function(val) {
    return val >= 10 ? val : '0' + val
})

Vue.filter('prePrice', function(val) {
    return parseInt(val)
})

Vue.filter('sfxPrice', function(val) {
    val = parseInt(val * 100)
    if (val == 0) {
        return '00'
    }
    var price = val % 100;
    return price >= 10 ? price : '0' + price
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  moment,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js